export function getTableColumnTooltip(key, store_key = null) {
    const tooltips = {
        'popularity': {
            'GOOGLE_PLAY': 'Google Play Popularity ranges from 0 to 100. As Google Play does not provide data on keyword popularity, this value is calculated based on indirect factors that may indicate the search popularity of a keyword.',
            'APP_STORE': 'App Store Popularity ranges from 5-100, a score of 5 indicates low search volume or none. We assign a special value of 1 for cases where we consistently receive a popularity value of 5 from the App Store for over 30 days, indicating extremely low or no search activity.'
        },
        'est_impressions': 'Est. Keyword Daily Impressions shows the estimated number of impressions a keyword receives each day within a given country. This is a keyword popularity metric; it does not refer to how many impressions your application will get based on its position.',
        'rank': {
            'GOOGLE_PLAY': 'App Rank - your app\'s ranking for this keyword in the Google Play search results for the specified country.',
            'APP_STORE': 'App Rank - your app\'s ranking for this keyword in the App Store search results for the specified country.'
        },
        'results': {
            'GOOGLE_PLAY': 'Results - the number of apps that rank for this keyword in the Google Play search results.',
            'APP_STORE': 'Results - the number of apps that rank for this keyword in the App Store search results.'
        },
        'difficulty': 'Difficulty: A measure of how challenging it would be to rank highly for this keyword, including factors such as competition and market saturation.',
        'comp_in_top_10': 'Competition In Top 10: Displays how many apps ranked in the top ten positions are marked as direct competitors, indirect competitors, or non-competitors.',
        'max_popularity': 'Max Popularity: The highest recorded popularity score over time for this keyword. It provides context on peak interest metrics.',
    };

    if (!tooltips[key]) {
        console.error(`Tooltip not found for key: ${key}`);
        return '';
    }

    if (store_key) {
        const base = tooltips[key];
        if (typeof base === 'string') {
            return base;
        }

        if (!base[store_key]) {
            console.error(`Tooltip not found for store key: ${key} ${store_key}`);
            return '';
        }

        return tooltips[key][store_key];
    }

    return tooltips[key];
}